import GilroyHeavy from '~/assets/fonts/Gilroy-Heavy.otf'
import GilroyBlack from '~/assets/fonts/Gilroy-Black.otf'
import GilroyBold from '~/assets/fonts/Gilroy-Bold.otf'
import GilroySemiBold from '~/assets/fonts/Gilroy-Semibold.otf'
import GilroyMedium from '~/assets/fonts/Gilroy-Medium.otf'
import GilroyRegular from '~/assets/fonts/Gilroy-Regular.otf'
import GilroyUltraLight from '~/assets/fonts/Gilroy-UltraLight.otf'

export const cssBaseLineConfig = {
  styleOverrides: `

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: bolder;
      src: local('Gilroy'), local('Gilroy-Heavy'), url(${GilroyHeavy}) format('opentype');
    }

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: 800;
      src: local('Gilroy'), local('Gilroy-Black'), url(${GilroyBlack}) format('opentype');
    }

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: 700;
      src: local('Gilroy'), local('Gilroy-Bold'), url(${GilroyBold}) format('opentype');
    }

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: 600;
      src: local('Gilroy'), local('Gilroy-Semibold'), url(${GilroySemiBold}) format('opentype');
    }

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: 500;
      src: local('Gilroy'), local('Gilroy-Medium'), url(${GilroyMedium}) format('opentype');
    }

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: 400;
      src: local('Gilroy'), local('Gilroy-Regular'), url(${GilroyRegular}) format('opentype');
    }

    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-display: swap;
      font-weight: 300;
      src: local('Gilroy'), local('Gilroy-UltraLight'), url(${GilroyUltraLight}) format('opentype');
    }


    `,
}
